import React from 'react'
import {Link as RouterLink} from 'react-router-dom'
import styled from 'styled-components'
import {Trans} from 'react-i18next'
import breakpoint from 'components/breakpoint'
import {ELEMENTS_IDS} from 'const'
import {GoogleAnalyticsService} from 'services'

const getLinkHover = props => props.theme.link.default
const getHoverColor = props => props.theme.link.hoverColor

const RegisterLinkView = styled.div`
  display: flex;
  flex-shrink: 0;
  padding-top: 20px;
  text-decoration: none;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: -4px;

  ${breakpoint('portrait')`
    padding-top: 0;
    margin-left: 20px;
    flex-direction: column;
    align-items: flex-start;
  `};
`

const RegisterLink = styled(RouterLink)`
  display: inline-block;
  color: ${getLinkHover};
  text-decoration: underline;
  margin-left: 4px;

  &:hover {
    color: ${getHoverColor};
  }

  ${breakpoint('landscape')`
    margin-left: 0;
  `};
`

const LogisterFormRegisterLink = ({getRegistrationLink}) => {
  const onLinkClickHandler = () => {
    GoogleAnalyticsService.trackRegistrationStart()
  }

  return (
    <RegisterLinkView>
      <Trans i18nKey="register.link">
        text
        <RegisterLink id={ELEMENTS_IDS.logisterPage.register} to={getRegistrationLink()} onClick={onLinkClickHandler}>
          text
        </RegisterLink>
      </Trans>
    </RegisterLinkView>
  )
}

export default LogisterFormRegisterLink
